import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { apiUrlInterceptor, authInterceptor, errorInterceptor } from '@core/interceptors';
import { provideIconInitializer } from './domains/shared/services/icon.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor, apiUrlInterceptor, errorInterceptor])),
    provideIconInitializer(),
  ],
};
